module.exports = __webpack_public_path__ + "img/1F600.01c2b898.svg";